export default __webpack_public_path__ + "static/media/ccgmplogo.9ceac503.png";